import { ErrorResponse } from './types';

export const getErrorMessages = (errorResponse: ErrorResponse) => {
  return errorResponse.message;
};

// Generic customer-facing explanation sent (as TTS) when the agent clicks a
// failed order line. Deliberately name-free: raw item names are POS-style and
// sound wrong spoken aloud, and BM readback names are templates HITL can't
// fill in.
export const getOrderErrorMessage = (isMenuModuleError: boolean) =>
  isMenuModuleError
    ? "I'm having trouble adding that item."
    : "I'm having trouble submitting your order.";
